module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.noCommonRouter.indexOf(_vm.$route.name) == -1) ? _c('div', {
    staticClass: "system",
    on: {
      "click": function($event) {
        _vm.openSelfCenter = false
      }
    }
  }, [_c('top-logo', {
    attrs: {
      "tab": _vm.tab,
      "crumbs": _vm.crumbs,
      "storeData": _vm.storeData,
      "openSelfCenter": _vm.openSelfCenter
    },
    on: {
      "showSideBar": _vm.showSideBar,
      "changeSelfCenter": _vm.changeSelfCenter
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "systemConBox",
    attrs: {
      "type": "flex"
    },
    on: {
      "click": _vm.showSideBar
    }
  }, [_c('el-col', {
    staticClass: "leftSidePart",
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "xs": 5,
      "sm": 5,
      "md": 4,
      "lg": 4
    }
  }, [_c('side-bar', {
    attrs: {
      "storeData": _vm.storeData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mainPart",
    attrs: {
      "xs": 19,
      "sm": 19,
      "md": 20,
      "lg": 20
    }
  }, [_c('keep-alive', {
    attrs: {
      "exclude": "goodsBigScreen"
    }
  }, [_c('router-view', {
    attrs: {
      "curStoreId": _vm.curStoreId,
      "pageSize": _vm.pageSize,
      "storeData": _vm.storeData
    }
  })], 1)], 1)], 1)], 1) : _c('div', {
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "width": "100vw",
      "height": "100vh"
    }
  }, [_c('router-view', {
    attrs: {
      "curStoreId": _vm.curStoreId,
      "pageSize": _vm.pageSize,
      "storeData": _vm.storeData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-782820cb","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/index.vue
// module id = 964
// module chunks = 1